import { useEffect } from "react";
import InteriorsHero from "./interiors/InteriorsHero";
import WhyInteriors from "./interiors/WhyInteriors";
import InteriorsPackages from "./interiors/InteriorsPackages";
import InteriorsProcess from "./interiors/InteriorsProcess";
import InteriorsLocations from "./interiors/InteriorsLocations";
import InteriorsFAQ from "./interiors/InteriorsFAQ";

const SERVICE_LOCATIONS = [
  "Manchester", "Liverpool", "London", "Birmingham", "Leeds", "Newcastle",
  "Sheffield", "Stoke-on-Trent", "Chester", "Stockport", "Brighton", "Essex",
  "Oxford", "Bath", "Slough", "Southampton", "Bristol",
];

export default function Interiors() {
  useEffect(() => {
    document.title = "Airbnb & Short-let Interior Design and Furnishing Packages UK | Truestays";

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOgMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", property); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    const description = "Professional interior design and furnishing packages for Airbnb and short-let properties, fully furnished and guest-ready within 7 days. Serving Manchester, Liverpool, London, Birmingham, Leeds and more UK cities. Get a free quote.";

    setMeta("description", description);
    setMeta("robots", "index, follow");
    setMeta("keywords", "Airbnb interior design, short-let furnishing, serviced accommodation interior design, Airbnb staging UK, furniture packages for landlords");
    setOgMeta("og:title", "Airbnb & Short-let Interior Design and Furnishing Packages UK | Truestays");
    setOgMeta("og:description", description);
    setOgMeta("og:type", "website");
    setOgMeta("og:url", window.location.origin + "/interiors");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = window.location.origin + "/interiors";

    // Structured data for local SEO — Service + areas served
    let ldJson = document.getElementById("interiors-ld-json");
    if (!ldJson) {
      ldJson = document.createElement("script");
      ldJson.id = "interiors-ld-json";
      ldJson.type = "application/ld+json";
      document.head.appendChild(ldJson);
    }
    ldJson.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Interior Design and Furnishing for Short-let and Airbnb Properties",
      "provider": {
        "@type": "Organization",
        "name": "Truestays",
        "url": "https://www.truestays.co.uk",
      },
      "areaServed": SERVICE_LOCATIONS.map((name) => ({ "@type": "City", "name": name })),
      "description": description,
    });

    return () => { ldJson?.remove(); };
  }, []);

  return (
    <>
      <InteriorsHero />
      <WhyInteriors />
      <InteriorsPackages />
      <InteriorsProcess />
      <InteriorsLocations />
      <InteriorsFAQ />
    </>
  );
}